import React from "react";
import "./MarketingServices.css";
import { FaArrowRight } from "react-icons/fa";

const MarketingCard = ({ service, index, onClick }) => {
  // const bgStyle = {
  //   background: `linear-gradient(135deg, ${service.accentColor}12 0%, ${service.accentColor}08 50%, ${service.accentColor}04 100%)`,
  //   border: `1px solid ${service.accentColor}15`,
  // };

  return (
    <div
      className="ms-card ms-animate-fadeInUp"
      style={{ animationDelay: `${index * 0.08}s` }}
      onClick={() => onClick && onClick(service)}
    >
      <div className="ms-card-inner">
        <div className="ms-card-icon-frame">
          <div className="ms-card-particles">
            {service.image && (
              <img
                src={service.image}
                alt={service.title}
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            )}
          </div>
          {/* <i
            className={`${service.icon} ms-card-icon-main`}
            style={{ color: service.accentColor }}
          /> */}
        </div>

        <div className="ms-card-info">
          <div>
            {service.category && (
              <span className="ms-category-tag">{service.category}</span>
            )}
          </div>

          <h3 className="ms-card-title">{service.title}</h3>

          {service.description && (
            <p className="ms-card-description">{service.description}</p>
          )}
        </div>

        <div className="ms-card-footer">
          <div className="ms-card-features">
            {service.features &&
              service.features.slice(0, 2).map((feature, idx) => (
                <span key={idx} className="ms-feature-pill">
                  {feature}
                </span>
              ))}
          </div>
          <div className="ms-card-arrow">
            <FaArrowRight size={15} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MarketingCard;
